import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Icon } from '@iconify/react/dist/iconify.js'
import { useDispatch, useSelector } from 'react-redux'
import { signInFailure, signInStart, signInSuccess } from '../redux/user/userSlice'
import { roleFailure, roleStart, roleSucess } from '../redux/role_access/role_access'
import { IndividualSuccess } from '../redux/individual_role/Individual_role'
import config from '../config'
import FailedMessage from '../components/child/FailedMessage'

const SignInLayer = () => {
  const [formData, setFormData] = useState({})
  const [confirmpassword, setconfirmPassword] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [showOtpModal, setShowOtpModal] = useState(false)
  const [otp, setOtp] = useState('')
  const [pendingNavigationData, setPendingNavigationData] = useState(null)
  const [data,setData] = useState()

  const user_data = useSelector((state) => state?.user)
  const user_role = useSelector((state) => state.roles)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  // Assign roles based on current user
  useEffect(() => {
    console.log(user_data,"==============================>>>>>")
    if (user_data?.currentUser?.role === "SuperAdmin" || user_data?.currentUser?.role === 'admin') {
      const role = {
        OverAll_dashboard: user_role?.currentRole?.find(d => d.name === "OverAll_dashboard"),
        Agency_dashboard: user_role?.currentRole?.find(d => d.name === "Agency_dashboard"),
        Inhouse_dashboard: user_role?.currentRole?.find(d => d.name === "Inhouse_dashboard"),
        loan_mapping: user_role?.currentRole?.find(d => d.name === "loan_mapping"),
        user_list: user_role?.currentRole?.find(d => d.name === "user_list"),
        add_user: user_role?.currentRole?.find(d => d.name === "add_user"),
        view_profile: user_role?.currentRole?.find(d => d.name === "view_profile"),
        role_access: user_role?.currentRole?.find(d => d.name === "role_access"),
        assign_role: user_role.currentRole?.find(d => d.name === "assign_role"),
        loan_details: user_role?.currentRole?.find(d => d.name === "loan_details"),
      }
      dispatch(IndividualSuccess(role))
    }

    if (user_data?.currentUser?.role === "StucredAgencies" || user_data?.currentUser?.role === "Agencies" 
    || user_data?.currentUser?.role === "Inhouse-Manager-Chennai" || user_data?.currentUser?.role === "Inhouse-Manager-Indore" || user_data?.currentUser?.role === "Inhouse-Manager-Banglore" || user_data?.currentUser?.role === "Inhouse-Manager-Mumbai" || user_data?.currentUser?.role === "Inhouse-Manager-Hyderabad" || user_data?.currentUser?.role === "Inhouse-Manager-Kolkata" || user_data?.currentUser?.role === "Inhouse-Manager-Delhi" || user_data?.currentUser?.role === "Inhouse-Manager-Pune"
    ) {
      const role = {
        Stucred_lead_dashboard: user_role?.currentRole?.find(d => d.name === "Stucred_lead_dashboard"),
        loan_details: user_role?.currentRole?.find(d => d.name === "loan_details"),
        loan_mapping: user_role.currentRole?.find(d => d.name === "loan_mapping"),
        agent_list: user_role?.currentRole?.find(d => d.name === "agent_list"),
        add_agent: user_role?.currentRole?.find(d => d.name === "add_agent"),
        view_profile: user_role?.currentRole?.find(d => d.name === "view_profile")
      }
      console.log(role,"=================role=============>>>>>")
      dispatch(IndividualSuccess(role))
    }

    if (user_data?.currentUser?.role === "StucredAgent" || user_data?.currentUser?.role === "Agent") {
      const role = {
        inhouse_dashboard: user_role?.currentRole.find(d => d.name === "inhouse_dashboard"),
        loan_details: user_role?.currentRole.find(d => d.name === "loan_details"),
        loan_mapping: user_role?.currentRole.find(d => d.name === "loan_mapping"),
        view_profile: user_role?.currentRole.find(d => d.name === "view_profile")
      }
      dispatch(IndividualSuccess(role))
    }
  }, [user_data, user_role, dispatch])

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value.trim() })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)

    if (!formData.email) {
      setIsLoading(false)
      return dispatch(signInFailure('Please fill all the fields'))
    }

    try {
      dispatch(signInStart())
      dispatch(roleStart())

      const res = await fetch(`${config.apiUrlBetaV2}signin`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      })

      let data = await res.json()
      setData(data)
      if (data.status === false) {
        setMessage(data.message)
        setIsLoading(false)
      }

      let token = data.token
      data = data.rest

      if (data.newUser === true) {
        setconfirmPassword(true)
        setShowPassword(true)
      } else {
        setShowPassword(true)
      }

      if (res.ok) {
        if (token) localStorage.setItem('access_token', token)
      }

      // Instead of navigating directly, show OTP modal
      if(showPassword == true && token){
           setPendingNavigationData({ token, data })
      setShowOtpModal(true)

      }
   
      setIsLoading(false)


    } catch (error) {
      dispatch(signInFailure(error.message))
      setIsLoading(false)
    }
  }

  // OTP verification
  const verifyOtp = async () => {
    if (!otp) {
      setMessage("Please enter OTP")
      return
    }

    try {
      const { token, data } = pendingNavigationData
      const res = await fetch(`${config.apiUrlBetaV2}verify_otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({ otp })
      })

      const result = await res.json()
      console.log(result,"====================================>>>")


      if (!result.status) {
        setMessage(result.message || "OTP verification failed")
        return
      }
                    dispatch(signInSuccess(data))

      setShowOtpModal(false)
      // Navigate based on role
      if(data.role === 'SuperAdmin' && data.newUser === false && showPassword == true && formData.password !== undefined ){ navigate('/overall'); 
        
      }else if(data.role === 'admin' && data.newUser === false && showPassword == true && formData.password !== undefined){
        navigate('/overall'); }else if(data.role === 'StucredAgencies' && data.newUser === false && formData.password !== undefined ){ 
          navigate('/Agency_loan_details') }else if(data.role === 'Agencies' && data.newUser === false && formData.password !== undefined ){ 
            navigate('/Agency_loan_details') }else if(data.role === "StucredAgent" && data.newUser === false && formData.password !== undefined || null){ 
        console.log(data,"==============rrr================>>>>>",data.role === "Inhouse-Manger-Chennai")
        navigate("/stucred_loan") }else if((data.role == "Inhouse-Manager-Chennai" || data.role == "Inhouse-Manager-Indore" || data.role === "Inhouse-Manager-Banglore" || data.role === "Inhouse-Manager-Mumbai" || data.role === "Inhouse-Manager-Hyderabad" || data.role === "Inhouse-Manager-Kolkata" || data.role === "Inhouse-Manager-Delhi" || data.role === "Inhouse-Manager-Pune ") && data.newUser === false && formData.password !== undefined || null){ 
          navigate("/Manager_loan_details") }else{
            navigate("/") }
            console.log("data.role",data.role)
            
    } catch (error) {
      setMessage("OTP verification failed")
    }
  }

  const handleHideMessage = () => setMessage('')

  return (
    <>

      <section className="auth bg-base d-flex flex-wrap">
        <div className="auth-left d-lg-block d-none">
          <div className="d-flex align-items-center flex-column h-100 justify-content-center">
            <img src="assets/images/login.jpg" alt="" />
          </div>
        </div>

        <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
          <div className="max-w-464-px mx-auto w-100">
            <div>
              <Link to="/" className="mb-40 max-w-290-px"></Link>
              <h4 className="mb-12">Sign In to your Stucred Collection</h4>
              <p className="mb-32 text-secondary-light text-lg">
                Welcome back! please enter your detail
              </p>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="icon-field mb-16">
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="mage:email" />
                </span>
                <input
                  type="email"
                  className="form-control h-56-px bg-neutral-50 radius-12"
                  placeholder="Email"
                  name='email'
                  id='email'
                  onChange={handleChange}
                />
              </div>

              {showPassword && (
                <div className="icon-field mb-16">
                  <input
                    type="password"
                    className="form-control h-56-px bg-neutral-50 radius-12"
                    placeholder="Password"
                    name='password'
                    id='password'
                    onChange={handleChange}
                  />
                </div>
              )}

              {confirmpassword && (
                <div className="icon-field mb-16">
                  <input
                    type="ConfirmPassword"
                    className="form-control h-56-px bg-neutral-50 radius-12"
                    placeholder="Confirm Password"
                    name='ConfirmPassword'
                    id='ConfirmPassword'
                    onChange={handleChange}
                  />
                </div>
              )}

              <div className="d-flex justify-content-between gap-2">
                <div className="form-check style-check d-flex align-items-center">
                  <input
                    className="form-check-input border border-neutral-300"
                    type="checkbox"
                    defaultValue=""
                    id="remeber"
                    onChange={handleChange}
                  />
                  <label className="form-check-label" htmlFor="remeber">
                    Remember me
                  </label>
                </div>
                <Link to="/forgot-password" className="text-primary-600 fw-medium">
                  Forgot Password?
                </Link>
              </div>

              <button
                type="submit"
                className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
                onClick={handleSubmit}
              >
                {isLoading ? (
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                ) : (
                  "Sign In"
                )}
              </button>

              <div className="mt-32 center-border-horizontal text-center">
                <span className="bg-base z-1 px-4">Or sign in with</span>
              </div>

              <div className='text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32'>
                <Link to={'/stucred_login'}
                  type="button"
                  className="fw-semibold text-primary-light py-16 px-12 w-100 border radius-12 text-md d-flex align-items-center justify-content-center gap-12 line-height-1 bg-hover-primary-50"
                >
                  <img
                    src="assets/images/stpng.png"
                    alt="image_user"
                    className="w-40-px h-40-px object-fit-cover rounded-circle"
                  /> Stucred
                </Link>
              </div>
            </form>
          </div>
                      {message && <FailedMessage message={message} onHide={handleHideMessage} />}
       {/* OTP Modal */}
{showOtpModal && (
  <div style={{
    position: "fixed",
    top: 0, left: 0,
    width: "100%", height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999
  }}>
    <div style={{
      backgroundColor: "#fff",
      padding: "30px",
      borderRadius: "8px",
      width: "350px",
      textAlign: "center",
      position: "relative" // needed for close button
    }}>
      {/* Close button */}
      <button
        onClick={() => setShowOtpModal(false)}
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          border: "none",
          background: "transparent",
          fontSize: "18px",
          cursor: "pointer"
        }}
      >
        &times;
      </button>

      <h5>Enter OTP</h5>
      {message && (
        <div style={{color: "red", marginBottom: "10px"}}>
          {message}
        </div>
      )}
      <input
        type="text"
        value={otp}
        onChange={(e) => setOtp(e.target.value)}
        placeholder="Enter 4-digit OTP"
        className="form-control mb-3"
      />
      <button className="btn btn-success w-100" onClick={verifyOtp}>
        Verify OTP
      </button>
    </div>
  </div>
)}


        </div>
 
      </section>


    </>
  )
}

export default SignInLayer
